(function ($) {
    $(document).ready(function () {

        $.fn.extend({
			elementExists: () => $(this).length > 0
        });
        
        function isPageID(pageID) {
            return $("body").is("#"+pageID);
        }

        function isPageClass(pageClass){
            return $("body").hasClass(pageClass);
        }

        function MOD(num, div) {
            return ((num%div)+div)%div;
        }

        function sleep(ms){
            let start = new Date().getTime(),
                end = start;
        
            while(end < start + ms) {
              end = new Date().getTime();
           }
        }

        const AVG_MINIMAL_AREA_NEEDED = 1,
            AREA_ERROR = 1.3;

        let appliances = {},
            grouped_appliances = {},
            solarPanels = {},
            all_products = {},
            inverters = {},
            batteries = {},
            totalWattHoursPerDay = 0,
            totalPowerSystemLoad = 0,
            maxPowerSystemLoadEffLoss = 0,
            inverterCalcAmt = 0,
            calcCheapestInverter = 0,
            calcLowestInputBatteryVoltageForInverter = 0,
            laTotalWattHours = 0,
            liTotalWattHours = 0,
            invertersCalculated = {},
            invertersOptions = {},
            batteriesCalculated = {},
            batteriesOptions = {};

        // Batteries Calculator Variables
        let totalViableBatteries = 0,
            avgNeededBatteries = 0,
            baConst = 0.5,
            avgLowNeededBatteries = 0,
            lowestCostBatteries = 0,
            leastNeededBatteries = 0;

        async function getAllProducts() {
            try {
                let response = await fetch(`https://solapowertech-api.herokuapp.com/get_products`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                            // 'Content-Type': 'application/x-www-form-urlencoded',
                          },
                    });
                let data = await response.json()
                return await data
            } catch(err) {
                console.error(err);
            }
        }

        async function getInverters(){
            try {
                
                let response = await fetch(`//cdn.shopify.com/s/files/1/0363/4082/6244/t/2/assets/inverters.json?v=3652149786719938234`);
                let data = await response.json();

                return await data;
            } catch(err) {
                console.error(err);
            }
        }

        async function getBatteries(){
            try {
                
                let response = await fetch(`//cdn.shopify.com/s/files/1/0363/4082/6244/t/2/assets/batteries.json?v=3652149786719938287`);
                let data = await response.json();

                return await data;
            } catch(err) {
                console.error(err);
            }
        }

        async function getAppliances(){
            try {
                
                let response = await fetch(`//cdn.shopify.com/s/files/1/0363/4082/6244/t/2/assets/calc-appliances.json?v=3652149786719938288`);
                let data = await response.json();

                return data;
            } catch(err) {
                console.error(err);
            }
        }

        async function getGroupAppliances(){
            try {
                
                let response = await fetch(`//cdn.shopify.com/s/files/1/0363/4082/6244/t/2/assets/calc-grouped-appliances.json?=${new Date().getTime()}`);
                let data = await response.json();

                return data;
            } catch(err) {
                console.error(err);
            }
        }

        async function getProducts(){
            [appliances, all_products, grouped_appliances] = await Promise.all([getAppliances(), getAllProducts(), getGroupAppliances()]);

            batteries = all_products.batteries.products
            inverters = all_products.inverters.products
            
            addAppliances(1);
        }

        function addAppliances(numOfAppliances) {
            let input_fields = ``;

            for(i = 0; i < numOfAppliances; i++){
                let appliances_select = ``;

                /* Object.keys(appliances).forEach(element => {
                    appliances_select += `<option value="${element}">${appliances[element].name}</option>`;
                }); */
                
                Object.keys(grouped_appliances).forEach(e => {
                    let options = Object.keys(grouped_appliances[e]).map(f => {
                        return `<option value="${f}">${grouped_appliances[e][f].name}</option>`
                    }).join('')
                
                    appliances_select += `<optgroup label="${e.replace('-', ' ')}">${options}</optgroup>`
                })

                let input_field = `<div class="calculator-fields-wrapper row ${numOfAppliances===1?"position-relative additional-field":""}">
                    <div class="calculator-field col-12 col-sm-4">
                        <select class="w-100">
                            <option value="">Select An Appliance</option>
                            ${appliances_select}
                        <select>
                    </div>
                    <div class="calculator-field col-3 col-sm-2">
                        <label>Quantity</label>
                        <input type="number" name="quantity" min="0" step="1" pattern="[0-9]" class="w-100" onkeyup=imposeNoDecimal(this) readonly/>
                    </div>
                    <div class="calculator-field col-3 col-sm-2">
                        <label>Watts</label>
                        <input type="number" name="watts" class="w-100" min="0" step="1" readonly/>
                    </div>
                    <div class="calculator-field col-3 col-sm-2">
                        <label>Hours Needed/Day</label>
                        <input type="number" name="hours" class="w-100" min="0" max="24" onkeyup=imposeMinMax(this) readonly/>
                    </div>
                    <div class="calculator-field col-3 col-sm-2">
                        <label>Total Watts Hours</label>
                        <input type="number" name="watts-hours" class="w-100" readonly/>
                    </div>
                    <div class="remove-field position-absolute">X</div>
                </div>`;

                input_fields += input_field;

            }
            
            $("#step-1 .calculator-fields-container .calculator-fields-content").append(input_fields);

            $("#step-1 .calculator-field select").change(e => {
                let currSelect = $(e.currentTarget),
                    currFieldContainer = currSelect.parents(".calculator-fields-wrapper"),
                    currAppliance = appliances[currSelect.val()];

                currFieldContainer.find('.alert-field').remove()
                if(currSelect.val()) {
                    let default_hours = currAppliance?.hours ?? 1

                    currFieldContainer.find("input[name='hours']").removeAttr("readonly").val(default_hours)
                    currFieldContainer.find("input[name='quantity'],input[name='watts']").removeAttr("readonly").val(1);
                    
                    let avgWatts = (currAppliance.low_power+currAppliance.high_power)/2;

                    currFieldContainer.find("input[name='watts']").val(avgWatts);
                    currFieldContainer.find("input[name='watts-hours']").val(avgWatts*default_hours);

                    if(avgWatts > 1000) {
                        currFieldContainer.prepend(`<div class="alert-field position-absolute"
                            message="Please note that this appliance is a high-power consumer. It will require a large sized inverter. It is not recommended that this is included unless necessary as it will increase the overall costs of your system considerably.">
                            <i data-feather="alert-circle"></i>
                        </div>`)

                        $('.alert-field').click(e => {
                            e.preventDefault()
                            
                            if($(e.currentTarget).hasClass('active')){
                                $(e.currentTarget).removeClass('active')
                            } else {
                                $(e.currentTarget).addClass('active')
                            }
                        })
                        feather.replace();
                    }
                } else {
                    currFieldContainer.find("input").attr("readonly", true).val("");
                }

                if(currFieldContainer.index() === 0) {
                    window.scrollTo({
                        top: document.querySelector('.show-recommendations').offsetTop,
                        behavior: 'smooth'
                    })
                }

                calculateTotals();
            });

            $('#step-1 .calculator-field input').on('focusin', (e) => {
                $(e.currentTarget).data('curr-val', $(e.currentTarget).val());
            });

            $('#step-1 .calculator-field input').keyup((e) => {
                let currentQty = Number($(e.currentTarget).data("curr-val"))
                let isHours = $(e.currentTarget).attr('name') === 'hours' && e.key === '.'
                if(isNaN(Number(e.key)) && !['ArrowRight', 'ArrowLeft', 'Backspace'].includes(e.key) && !isHours) {
                    $(e.currentTarget).val(currentQty)
                }
            });

            $("#step-1 .calculator-field input").change(e => {
                let currInput = $(e.currentTarget),
                    currFieldContainer = currInput.parents(".calculator-fields-wrapper"),
                    currAppliance = appliances[currFieldContainer.find("select").val()];

                let qty = currFieldContainer.find("input[name='quantity']").val(),
                    watts = currFieldContainer.find("input[name='watts']").val(),
                    hours = currFieldContainer.find("input[name='hours']").val();

                currFieldContainer.find("input[name='watts-hours']").val(qty*watts*hours);

                calculateTotals();
            });

            $(".remove-field").click(e => {
                e.preventDefault();
                let fieldWrapper = $(e.currentTarget).parents(".calculator-fields-wrapper");

                if(fieldWrapper.index() <= 0) {
                    $(e.currentTarget).siblings('.calculator-field:first-of-type').find('select').val('').change()
                } else {
                    fieldWrapper.remove();
                }

                calculateTotals();
            });
        }

        function resetVariables(){
            totalWattHoursPerDay = 0;
            totalPowerSystemLoad = 0;
            inverterCalcAmt = 0;
            calcCheapestInverter = 0;
            calcLowestInputBatteryVoltageForInverter = 0;
            totalViableBatteries = 0;
            invertersCalculated = {};
            invertersOptions = {};
            batteriesCalculated = {};
            batteriesOptions = {};
        }
        
        function calculateTotals() {

            resetVariables();

            $("#step-1 .calculator-fields-wrapper").each((i, element) => {
                let wattsHours = $(element).find("input[name='watts-hours']").val(),
                    averagePower = $(element).find("input[name='watts']").val(),
                    quantity = $(element).find("input[name='quantity']").val();

                if(wattsHours && averagePower){
                    totalWattHoursPerDay += Number(wattsHours);
                    totalPowerSystemLoad += (Number(averagePower)*Number(quantity));
                }
            });

            totalWattHoursPerDay = Number(totalWattHoursPerDay.toFixed(2));
            maxPowerSystemLoadEffLoss = Number((totalPowerSystemLoad*1.3).toFixed(2));
            inverterCalcAmt = maxPowerSystemLoadEffLoss;
            // totalWattHoursPerDay = 6525;
            // maxPowerSystemLoadEffLoss = 2210;
            // totalPowerSystemLoad = 1700;
            // inverterCalcAmt = 2210;
            laTotalWattHours = Number((totalWattHoursPerDay*1.2*2*1.05*1.11).toFixed(2));
            liTotalWattHours = Number((totalWattHoursPerDay*1.05*1.25*1.05*1.05).toFixed(2));

            $(".calculator-results-block#total-watts-hours span").html(totalWattHoursPerDay);

            invertersCalculator();
            invertersCalculatorComplete();
            batteriesCalculator();
        }

        function invertersCalculator() {
            let arrInverterOptions = [],
                arrInverterCosts = [];

            Object.keys(inverters).forEach((inverter) => {
                let invPowerPerReqPower = Number(inverters[inverter].metafields.maxACOutputPower)/inverterCalcAmt,
                    efficiencyCheck = (invPowerPerReqPower > 1.3 && invPowerPerReqPower < 3);

                if(efficiencyCheck) {
                    arrInverterOptions.push(Number(inverters[inverter].metafields.maxVoltage));
                    arrInverterCosts.push(Number(inverters[inverter].cost));
                } else {
                    $('.no-recommendations .calculator-disclaimer .power-requirements').text(invPowerPerReqPower < 1.3 ? 'high' : 'low')
                }

                invertersCalculated[inverter] = { 
                    invPowerPerReqPower,
                    efficiencyCheck
                };
            });

            calcCheapestInverter = Math.min(...arrInverterCosts);
        }

        function invertersCalculatorComplete() {
            let arrBatteryVoltageForInverter = [];

            Object.keys(invertersCalculated).forEach(inverter => {
                if(invertersCalculated[inverter].efficiencyCheck) {
                    let isCheapestOption = (Number(inverters[inverter].cost) === calcCheapestInverter),
                        tallyUpOptions = isCheapestOption,
                        viableOption = tallyUpOptions;

                    if(viableOption) {
                        arrBatteryVoltageForInverter.push(Number(inverters[inverter].metafields.batteryVoltage));

                        invertersCalculated[inverter] = {
                            ...invertersCalculated[inverter],
                            isCheapestOption,
                            tallyUpOptions,
                            viableOption
                        };
                    }
                }
            });

            calcLowestInputBatteryVoltageForInverter = Math.min(...arrBatteryVoltageForInverter);

            Object.keys(invertersCalculated).forEach(inverter => {
                if(invertersCalculated[inverter].viableOption) {
                    let finalBatteryVoltageCheck = (Number(inverters[inverter].metafields.batteryVoltage) === calcLowestInputBatteryVoltageForInverter);

                    if(finalBatteryVoltageCheck) {
                        invertersOptions[inverter] = {
                            ...invertersCalculated[inverter],
                            finalBatteryVoltageCheck
                        };
                    }
                }
            });
        }

        function batteriesCalculator() {
            let arrBatteriesCosts = [],
                arrTotalBatteriesNeeded = [],
                overallBatteriesNeeded = 0;

            Object.keys(batteries).forEach(battery => {
                let numBatteriesNeeded = 0,
                    truncing = 0,
                    available = false;

                if(batteries[battery].metafields.batteryType === "LA") {
                    numBatteriesNeeded = laTotalWattHours / Number(batteries[battery].metafields.nominalCapacity);
                } else {
                    numBatteriesNeeded = liTotalWattHours / Number(batteries[battery].metafields.nominalCapacity);
                }

                truncing = numBatteriesNeeded - Math.trunc(numBatteriesNeeded);
                available = (truncing > 0);
                numBatteriesNeededRounded = Math.ceil(numBatteriesNeeded);
                
                let batteriesNeededInSeries = calcLowestInputBatteryVoltageForInverter / Number(batteries[battery].metafields.voltage),
                    batteriesNeededInSeriesRounded = Math.ceil(batteriesNeededInSeries),
                    batteriesNeededInParallel = numBatteriesNeededRounded / batteriesNeededInSeriesRounded,
                    batteriesNeededInParallelRounded = Math.ceil(batteriesNeededInParallel),
                    totalBatteriesNeeded = batteriesNeededInSeriesRounded * batteriesNeededInParallelRounded,
                    totalCostBatteries = Number(batteries[battery].cost) * totalBatteriesNeeded;

                if(available){
                    totalViableBatteries++;
                    overallBatteriesNeeded += totalBatteriesNeeded;
                    arrBatteriesCosts.push(totalCostBatteries);
                    arrTotalBatteriesNeeded.push(totalBatteriesNeeded);
                }

                batteriesCalculated[battery] = {
                    numBatteriesNeeded,
                    truncing,
                    available,
                    numBatteriesNeededRounded,
                    batteriesNeededInSeries,
                    batteriesNeededInSeriesRounded,
                    batteriesNeededInParallel,
                    batteriesNeededInParallelRounded,
                    totalBatteriesNeeded,
                    totalCostBatteries
                };
            });

            avgNeededBatteries = overallBatteriesNeeded / totalViableBatteries;
            avgLowNeededBatteries = avgNeededBatteries * baConst;
            lowestCostBatteries = Math.min(...arrBatteriesCosts);
            leastNeededBatteries = Math.min(...arrTotalBatteriesNeeded);

            Object.keys(batteriesCalculated).forEach(battery => {
                let hasLeastAmtNeeded = (batteriesCalculated[battery].totalBatteriesNeeded === leastNeededBatteries),
                    isCheapestOption = (batteriesCalculated[battery].totalCostBatteries === lowestCostBatteries),
                    isViable = (hasLeastAmtNeeded || isCheapestOption);

                if(isViable) {
                    batteriesOptions[battery] = {
                        ...batteriesCalculated[battery],
                        hasLeastAmtNeeded,
                        isCheapestOption,
                        isViable
                    };
                }
                
            });
        }

        function productTemplate(index, product) {
            return `<div class="row suggestion-category-product" data-variant-id="${product.id}" data-collection="${product.collection}">
                <div class="col-1 ${product.collection === 'inverters' ? 'd-none' : '' }">
                    <h4 class="product-option my-0">${index+1}
                </div>
                <div class="col-2 ${product.collection === 'inverters' ? 'd-none' : '' }">
                    <h4 class="product-benefit">${product.isCheapestOption ? 'Cheapest' : product.hasLeastAmtNeeded ? 'Least Qty Needed' : product.hasLeastAreaNeeded ? 'Least Area Needed' : 'Most Viable' }</h4>
                </div>
                <div class="${product.collection === 'inverters' ? 'col-5 col-md-4' : 'col-4'}">
                    <h4 class="product-name my-0" data-name="${product.name}">${product.name}</h4>
                </div>
                <div class="${product.collection === 'inverters' ? 'col-3' : 'col-2' }">
                    <p class="product-cost my-0" data-cost="${product.cost}">R ${product.cost}</p>
                </div>
                <div class="${product.collection === 'inverters' ? 'col-3' : 'col-1' } d-none d-md-block">
                    <p class="product-count my-0" data-count="${product.count}">${product.collection === 'inverters' ? product.maxACOutputPower+'W' : product.count}</p>
                </div>
                <div class="col-4 col-md-2  justify-content-end">
                    <a href=#" class="btn btn-rec-moreinfo mr-2" title="Design specifications">
                        ${feather.icons.info.toSvg()}
                    </a>
                    <a href="#" class="btn btn-rec-addtocard" title="Add to cart">
                        ${feather.icons['shopping-cart'].toSvg()}
                    </a>
                </div>
            </div>`;
        }

        function formatMoneyCurrency(price){
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'ZAR', currencyDisplay: 'narrowSymbol' }).format(price);
        }

        function productInfoTemplate(productOption, product, collection) {
            let productInfoHTML = `<div>Product Info</div>`;

            if (collection === 'inverters') {
                productInfoHTML = `<div class="productInfoWrapper">
                    <p>Maximum AC Power Output: ${product.metafields.maxACOutputPower} V</p>
                    <p>Maximum Solar Charge Current: ${product.metafields.maxSolarChargeCurrent} AH</p>
                    <p>DC Input Voltage Range: ${product.metafields.minVoltage} - ${product.metafields.maxVoltage} V</p>
                    <p>Max Voltage Input: ${product.metafields.maxVoltage} V</p>
                    <p>Battery Voltage: ${product.metafields.batteryVoltage} V</p>
                    <p>Total Cost: R ${formatMoneyCurrency(product.cost)}</p>
                </div>`
            } else if (collection === 'batteries') {
                productInfoHTML = `<div class="productInfoWrapper">
                    <p>Capacity: ${product.metafields.nominalCapacity}AH</p>
                    <p>Number of Batteries in Series: ${productOption.batteriesNeededInSeriesRounded}</p>
                    <p>Number of Batteries in Parallel: ${productOption.batteriesNeededInParallelRounded}</p>
                    <p>Total Batteries Needed: ${productOption.totalBatteriesNeeded}</p>
                    <p>Benefit of Option: ${productOption.isCheapestOption ? 'Cheapest' : productOption.hasLeastAmtNeeded ? 'Least Qty Needed' : 'Most Viable'}</p>
                    <p>Total Cost: R ${formatMoneyCurrency(productOption.totalCostBatteries)}</p>
                </div>`
            }

            return productInfoHTML;
        }

        function displaySuggestedProducts() {

            $(".tab-pane .row.suggestion-category-product").remove();

            Object.keys(invertersOptions).forEach((inverter, i) => {
                if(inverters[inverter].metafields.useInCalculations === "true") {
                    $("#inverters").append(productTemplate(i, {
                        id:inverters[inverter].variants[0],
                        name:inverters[inverter].title,
                        cost:Number(inverters[inverter].cost),
                        maxACOutputPower: inverters[inverter].metafields.maxACOutputPower,
                        productInfo: inverters[inverter].metafields.productDocument,
                        collection: 'inverters',
                        count: 1
                    }));
                }
            });

            Object.keys(batteriesOptions).forEach((battery, i) => {
                if(batteries[battery].metafields.useInCalculations === "true") {
                    $("#batteries").append(productTemplate(i, {
                        id:batteries[battery].variants[0],
                        name:batteries[battery].title,
                        cost:batteriesOptions[battery].totalCostBatteries,
                        count:batteriesOptions[battery].totalBatteriesNeeded,
                        productInfo: batteries[battery].metafields.productDocument,
                        isCheapestOption: batteriesOptions[battery].isCheapestOption,
                        hasLeastAmtNeeded: batteriesOptions[battery].hasLeastAmtNeeded,
                        isViable: batteriesOptions[battery].isViable,
                        collection: 'batteries'
                    }));
                }
            });

            $(".btn-rec-moreinfo").click(e => {
                e.preventDefault()

                let variant_id = $(e.currentTarget).parents(".suggestion-category-product").data("variant-id");
                let product_collection = $(e.currentTarget).parents(".suggestion-category-product").data("collection");
                let products = product_collection === 'inverters' ? inverters : batteries
                let productsOptions = product_collection === 'inverters' ? invertersOptions : batteriesOptions

                let product = Object.values(products).find(e => Number(e.variants[0]) === variant_id)

                let productInfo = productInfoTemplate(productsOptions[product.handle], product, product_collection)
                
                $('#moreInfoModalLabel').text(product.title)
                $('#moreInfoModal .modal-body').html(productInfo)
                
                if (product.metafields.productDocument) {
                    $('#moreInfoModal .modal-footer .btn-specs-sheet').removeClass('d-none')
                    $('#moreInfoModal .modal-footer .btn-specs-sheet').attr('href', product.metafields.productDocument)
                } else {
                    $('#moreInfoModal .modal-footer .btn-specs-sheet').addClass('d-none')
                }

                $('#moreInfoModal').modal('show')
            })

            $(".btn-cart, .btn-rec-addtocard").click(e => {
                e.preventDefault();
                
                let variant_id = $(e.currentTarget).parents(".suggestion-category-product").data("variant-id");
                let qty = $(e.currentTarget).parents(".suggestion-category-product").find("*[data-count]").data("count") || 1

                let formData = {
                    'items': [{
                        'id': variant_id,
                        'quantity': qty
                    }]
                };
                
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response =>  response.json())
                .then(response => {
                    populateSideCart()
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            });
        }

        if(isPageID("backup-system-design-tool")) {
            $(".start-input-btn").click(e => {
                e.preventDefault();

                $('#shopify-section-page-header').addClass('calculator-started');
                // document.getElementById('shopify-section-backup-calculator').scrollIntoView({behavior:'smooth'});
            });

            getProducts();

            $(".btn-add-appliance").click(e => {
                e.preventDefault();
                addAppliances(1);
            });

            $(".btn-clear-fields").click(e => {
                e.preventDefault();
                
                $("#step-1 .calculator-fields-content .additional-field").remove();
                $("#step-1 .calculator-fields-content select, #step-1 .calculator-fields-content input").val("");

                calculateTotals();
            });

            $(".show-recommendations").click(e => {
                let hasRecommendations = Object.keys(invertersOptions).length >= 1 && Object.keys(batteriesOptions).length >= 1

                $("#shopify-section-backup-calculator").addClass("calculation-done");
                $("#shopify-section-backup-recommendations .section-content, .recommendations-cta").removeClass("d-none");
                $('.no-recommendations').addClass('d-none');

                if(!hasRecommendations) {
                    $('.no-recommendations').removeClass('d-none');
                    $("#shopify-section-backup-recommendations .section-content, .recommendations-cta").addClass("d-none");
                    document.getElementById('shopify-section-backup-recommendations').scrollIntoView({behavior:'smooth'});
                    return;
                }
                displaySuggestedProducts();

                document.getElementById('shopify-section-backup-recommendations').scrollIntoView({behavior:'smooth'});
            });

            $(".btn-scroll-recommendations").click(e => {
                $(".show-recommendations").click();
            });

            $(".system-diagram .diagram-click-area").click(e => {
                e.preventDefault();

                let currClickArea = $(e.currentTarget),
                    clickAreaId = currClickArea.attr("id");
                    
                switch(clickAreaId) {
                    case 'click-bu-inverter' : {
                        $("#nav-tab #nav-inverters-tab").click();
                        break;
                    }
                    case 'click-bu-batteries' : {
                        $("#nav-tab #nav-batteries-tab").click();
                        break;
                    }
                    default:
                        break;
                }
                
                $('.diagram-click-area').removeClass('active')
                currClickArea.addClass('active')
            });

            $("#shopify-section-page-header").css('height',`calc(100vh - ${document.querySelector('#shopify-section-header').offsetHeight}px)`)

            $(document).click(() => {
                if($('.alert-field').hasClass('active')) {
                    $('.alert-field').removeClass('active')
                }
            })
        }
    });
})(jQuery);

function imposeMinMax(el){
    if(el.value != ""){
      if(parseInt(el.value) < parseInt(el.min)){
        el.value = el.min;
      }
      if(parseInt(el.value) > parseInt(el.max)){
        el.value = el.max;
      }
    }
}

function imposeNoDecimal(el) {
    if(el.value != "") {
        el.value = Math.round(Number(el.value))
    }
}